import {Trans} from 'react-i18next';
import {Field} from 'formik';
import ColorField from '../../../../../components/product/color/colorfield';
import React from 'react';
import InfoDialog from '../../../../../components/dialogs/InfoDialog';
import LeftTitleWithField from '../../layout/LeftTitleWithField';
import Section from '../../layout/Section';

export default function ColorThemeSetting() {
  return (
    <Section
      title={
        <Trans i18nKey="p.s.uiconfiguration.common.theme.colors">
          Theme Colors
        </Trans>
      }
    >
      <p className="kt-margin-t-10">
        <Trans i18nKey="p.s.uiconfiguration.common.theme.colors.desc">
          Customize your app theme by setting the colors below. These will
          define the overall look and feel of your interface.
        </Trans>
      </p>
      <LeftTitleWithField
        title={
          <>
            <Trans i18nKey="p.s.uiconfiguration.common.theme.colors.action.button.title">
              Color 1: Call to Action Buttons
            </Trans>
            &nbsp;
            <InfoDialog
              trigger={'click'}
              placement="right"
              title={
                <Trans i18nKey="p.s.uiconfiguration.common.theme.colors.action.button.title">
                  Color 1: Call to Action Buttons
                </Trans>
              }
              description={
                <div>
                  <Trans i18nKey="p.s.uiconfiguration.common.theme.colors.button.desc">
                    This color will be applied to the components below. You can
                    also view it in the following UI Configuration pages after
                    saving.
                  </Trans>
                  <img
                    style={{width: '100%', paddingTop: '1rem'}}
                    alt=""
                    src={require('../../../../../assets/images/skincare/common/theme-color-hint-1.png')}
                  />
                </div>
              }
            >
              <i className="fa fa-question-circle cursor-help" />
            </InfoDialog>
          </>
        }
      >
        <div className="col-5">
          <Field name="theme.color.actionButton" component={ColorField} />
        </div>
      </LeftTitleWithField>
      <LeftTitleWithField
        title={
          <>
            <Trans i18nKey="p.s.uiconfiguration.common.theme.colors.primary.title">
              Color 2: Primary Color
            </Trans>
            &nbsp;
            <InfoDialog
              trigger={'click'}
              placement="right"
              title={
                <Trans i18nKey="p.s.uiconfiguration.common.theme.colors.primary.title">
                  Color 2: Primary Color
                </Trans>
              }
              description={
                <div>
                  <Trans i18nKey="p.s.uiconfiguration.common.theme.colors.button.desc">
                    This color will be applied to the components below. You can
                    also view it in the following UI Configuration pages after
                    saving.
                  </Trans>
                  <img
                    style={{width: '100%', paddingTop: '1rem'}}
                    alt=""
                    src={require('../../../../../assets/images/skincare/common/theme-color-hint-2.png')}
                  />
                </div>
              }
            >
              <i className="fa fa-question-circle cursor-help" />
            </InfoDialog>
          </>
        }
      >
        <div className="col-5">
          <Field name="theme.color.primary" component={ColorField} />
        </div>
      </LeftTitleWithField>
      <LeftTitleWithField
        title={
          <>
            <Trans i18nKey="p.s.uiconfiguration.common.theme.colors.secondary.title">
              Color 3: Secondary Color
            </Trans>
            &nbsp;
            <InfoDialog
              trigger={'click'}
              placement="right"
              title={
                <Trans i18nKey="p.s.uiconfiguration.common.theme.colors.secondary.title">
                  Color 3: Secondary Color
                </Trans>
              }
              description={
                <div>
                  <Trans i18nKey="p.s.uiconfiguration.common.theme.colors.button.desc">
                    This color will be applied to the components below. You can
                    also view it in the following UI Configuration pages after
                    saving.
                  </Trans>
                  <img
                    style={{width: '100%', paddingTop: '1rem'}}
                    alt=""
                    src={require('../../../../../assets/images/skincare/common/theme-color-hint-3.png')}
                  />
                </div>
              }
            >
              <i className="fa fa-question-circle cursor-help" />
            </InfoDialog>
          </>
        }
      >
        <div className="col-5">
          <Field name="theme.color.secondary" component={ColorField} />
        </div>
      </LeftTitleWithField>
      <LeftTitleWithField
        title={
          <>
            <Trans i18nKey="p.s.uiconfiguration.common.theme.colors.secondary2.title">
              Color 4: Secondary Color Ⅱ
            </Trans>
            &nbsp;
            <InfoDialog
              trigger={'click'}
              placement="right"
              title={
                <Trans i18nKey="p.s.uiconfiguration.common.theme.colors.secondary2.title">
                  Color 4: Secondary Color Ⅱ
                </Trans>
              }
              description={
                <div>
                  <Trans i18nKey="p.s.uiconfiguration.common.theme.colors.button.desc">
                    This color will be applied to the components below. You can
                    also view it in the following UI Configuration pages after
                    saving.
                  </Trans>
                  <img
                    style={{width: '100%', paddingTop: '1rem'}}
                    alt=""
                    src={require('../../../../../assets/images/skincare/common/theme-color-hint-4.png')}
                  />
                </div>
              }
            >
              <i className="fa fa-question-circle cursor-help" />
            </InfoDialog>
          </>
        }
      >
        <div className="col-5">
          <Field name="theme.color.secondary2" component={ColorField} />
        </div>
      </LeftTitleWithField>
    </Section>
  );
}
